import { render, staticRenderFns } from "./BannerServiceDetails.vue?vue&type=template&id=177191c2&"
import script from "./BannerServiceDetails.vue?vue&type=script&lang=js&"
export * from "./BannerServiceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports